import { EmailField, EmailFieldProps } from '@cademy-ui/form';
import { FunctionComponent } from 'react';

export type CustomEmailFieldProps = EmailFieldProps;

export const CustomEmailField: FunctionComponent<CustomEmailFieldProps> = (props) => {
    const description =
        props.disabled && !props.description
            ? 'You cannot edit this email address.'
            : props.description;
    return <EmailField {...props} description={description} />;
};
